module.exports = __webpack_public_path__ + "img/slide3.e7d697f1.png";